// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-popper--theme-tooltip .v-popper__inner {\n  padding: 6px 12px;\n  background: #263238;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n}\n.v-popper--theme-tooltip .v-popper__arrow-outer {\n  border-color: #263238;\n}\n", ""]);
// Exports
module.exports = exports;
